import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import HeaderLogo from "./HeaderLogo.svg";
import Icon from "basic-elements/Icon";
import addPV from "utils/add-pv.js";
import { Store } from "public-components/StoreProvider";
import styles from "./MobileHeader.module.scss";

import HeaderI18n from "constants/HeaderI18n.js";
import menuListData from "./FeaturePagesMenuData.json";
import languageMenuArray from "./LanguageMenuData.json";
import multipleSiteEnum from "constants/multipleSiteEnum.js";

const MobileHeader = props => {
  const { state } = React.useContext(Store);
  const { siteId, isHomepage } = props;
  const tabsList = props.headerData.navigation;
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [menuLv2Key, setMenuLv2Key] = React.useState("");
  const [menuLv3Key, setMenuLv3Key] = React.useState("");

  const i18n = HeaderI18n[props.siteId];

  const updateMenuLv2Key = key => {
    if (menuLv2Key === key) {
      setMenuLv2Key("");
      setMenuLv3Key("");
    } else {
      setMenuLv2Key(key);
      setMenuLv3Key("");
    }
  };

  const updateMenuLv3Key = key => {
    if (menuLv3Key === key) {
      setMenuLv3Key("");
    } else {
      setMenuLv3Key(key);
    }
  };

  return (
    <header className={styles.header}>
      <div className={styles.header__row}>
        <a href="/" className={styles.header__logo} aria-label="fotor">
          <HeaderLogo />
        </a>

        {state.messageData && !!state.messageData.unreadNum && (
          <a className={styles.messageBell} href="https://www.fotor.com/user/settings#userMsg">
            <Icon className={styles.messageBell__icon} name="bell" size={24} />
            <span className={styles.messageBell__sup}>{state.messageData.unreadNum}</span>
          </a>
        )}

        <button
          className={styles.header__dropdownTrigger}
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          {isDropdownOpen ? <Icon name="close" size={24} /> : <Icon name="hamburger" size={24} />}
        </button>
      </div>

      <div
        className={styles.header__dropdownMenu}
        style={{ display: isDropdownOpen ? "block" : "none" }}
      >
        {state.userInfo ? (
          <>
            <div
              className={classnames(styles.link_lv1, menuLv2Key === "user" ? styles.active : null)}
              onClick={() => updateMenuLv2Key("user")}
            >
              <img className={styles.link_lv1__userAvatar} alt="" src={state.userInfo.headerUrl} />
              <span className={styles.link_lv1__userName}>{state.userInfo.nickName}</span>
              <Icon name="arrow-down-large" size={24} className={styles.link_lv1__arrow} />
            </div>
            <div
              className={classnames(styles.menu_lv2, menuLv2Key === "user" ? styles.active : null)}
            >
              <a href="https://www.fotor.com/user/settings" className={styles.link_lv2}>
                {i18n.myAccount}
              </a>
              <a href="https://www.fotor.com/user/settings#userMsg" className={styles.link_lv2}>
                {i18n.message}
                {state.messageData && !!state.messageData.unreadNum && (
                  <span className={styles.messageBubble}>{state.messageData.unreadNum}</span>
                )}
              </a>
              <a href="https://www.fotor.com/my/works/" className={styles.link_lv2}>
                {i18n.myWork}
              </a>
              <a
                href={`https://www.fotor.com/portfolio/${state.userInfo.id}`}
                className={styles.link_lv2}
              >
                {i18n.myPublicPortfolio}
              </a>
              <span className={styles.link_lv2} onClick={props.logoutFunc}>
                {i18n.logOut}
              </span>
            </div>
          </>
        ) : (
          <div className={styles.link_lv1} onClick={props.showAuthModalFunc}>
            <Icon name="sign-in" size={24} className={styles.link_lv1__icon} />
            {i18n.signIn}
          </div>
        )}
        <a href="https://www.fotor.com/photo-editor-app/" className={styles.link_lv1}>
          <Icon name="photo-editing" size={24} className={styles.link_lv1__icon} />
          {i18n.edit}
        </a>
        <a href="https://www.fotor.com/app.html#/collage/new/classic" className={styles.link_lv1}>
          <Icon name="photo-collage" size={24} className={styles.link_lv1__icon} />
          {i18n.collage}
        </a>
        <a href="https://www.fotor.com/app.html#/design" className={styles.link_lv1}>
          <Icon name="design" size={24} className={styles.link_lv1__icon} />
          {i18n.design}
        </a>
        <div
          className={classnames(styles.link_lv1, menuLv2Key === "features" ? styles.active : null)}
          onClick={() => updateMenuLv2Key("features")}
        >
          <Icon name="features" size={24} className={styles.link_lv1__icon} />
          {i18n.features}
          <Icon name="arrow-down-large" size={24} className={styles.link_lv1__arrow} />
        </div>
        <div
          className={classnames(styles.menu_lv2, menuLv2Key === "features" ? styles.active : null)}
        >
          {tabsList.map(i => {
            if (!menuListData[siteId][i.slug]) return null;
            return (
              <React.Fragment key={i.title}>
                <div
                  className={classnames(
                    styles.link_lv2,
                    i.slug === menuLv3Key ? styles.active : null
                  )}
                  onClick={() => updateMenuLv3Key(i.slug)}
                >
                  {i.title}
                  <Icon name="arrow-down-large" size={24} className={styles.link_lv2__arrow} />
                </div>
                <div
                  className={classnames(
                    styles.menu_lv3,
                    i.slug === menuLv3Key ? styles.active : null
                  )}
                >
                  {menuListData[siteId][i.slug].map(j => {
                    if (isHomepage) {
                      return (
                        <a
                          className={styles.link_lv3}
                          key={j.title}
                          href={j.url}
                          onClick={e =>
                            addPV(e, "trackEvent", {
                              category: "homePage-function",
                              action: "functionEnter_click",
                              label: `up|feature|${
                                tabsList.filter(z => z.slug === i.slug)[0].title
                              }|${j.title}`,
                              path: j.url,
                              openInNewTab: false
                            })
                          }
                        >
                          {j.title}
                        </a>
                      );
                    }
                    return (
                      <a className={styles.link_lv3} key={j.title} href={j.url}>
                        {j.title}
                      </a>
                    );
                  })}
                </div>
              </React.Fragment>
            );
          })}
        </div>
        <div
          className={classnames(styles.link_lv1, menuLv2Key === "language" ? styles.active : null)}
          onClick={() => updateMenuLv2Key("language")}
        >
          <Icon name="language" size={24} className={styles.link_lv1__icon} />
          {i18n.languages}
          <Icon name="arrow-down-large" size={24} className={styles.link_lv1__arrow} />
        </div>
        <div
          className={classnames(styles.menu_lv2, menuLv2Key === "language" ? styles.active : null)}
        >
          {languageMenuArray[siteId].map((i, idx) => {
            if (isHomepage) {
              return (
                <a
                  key={i.name}
                  href={multipleSiteEnum[idx + 1] === "en" ? "/" : "/" + multipleSiteEnum[idx + 1]}
                  className={classnames(styles.link_lv2, siteId === idx + 1 ? styles.active : null)}
                  onClick={e =>
                    addPV(e, "trackEvent", {
                      category: "homePage-userSetting",
                      action: "userSetting_click",
                      label: `language|${multipleSiteEnum[idx + 1]}`,
                      path:
                        multipleSiteEnum[idx + 1] === "en" ? "/" : "/" + multipleSiteEnum[idx + 1],
                      openInNewTab: false
                    })
                  }
                >
                  <strong>{i.title}</strong>({i.name})
                  {siteId === idx + 1 && (
                    <Icon name="tick" className={styles.link_lv2__activeIcon} />
                  )}
                </a>
              );
            }
            return (
              <a
                key={i.name}
                href={multipleSiteEnum[idx + 1] === "en" ? "/" : "/" + multipleSiteEnum[idx + 1]}
                className={classnames(styles.link_lv2, siteId === idx + 1 ? styles.active : null)}
              >
                <strong>{i.title}</strong>({i.name})
                {siteId === idx + 1 && <Icon name="tick" className={styles.link_lv2__activeIcon} />}
              </a>
            );
          })}
        </div>
      </div>
    </header>
  );
};

MobileHeader.propTypes = {
  siteId: PropTypes.number,
  showAuthModalFunc: PropTypes.func,
  logoutFunc: PropTypes.func,
  isHomepage: PropTypes.bool
};

export default MobileHeader;
